module.exports = __webpack_public_path__ + "static/media/chicagoBlue_redCropping.be46d56d.png";